import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'

// import Help from 'help'


import App from './App.vue'
import {routes} from './routes'



// setting for router
Vue.use(VueRouter);

// setting for resource
Vue.use(VueResource);
Vue.http.options.beforeSend = function(request) {
    request.headers['Content-Type'] = 'application/json; charset=utf-8';
};
Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;

Vue.filter('projectTypeMap', (value) => {
    if (value === 1) {
      return 'PGNAT'
    } else if (value === 2) {
      return 'GNAT'
    } else if (value === 3) {
      return 'APT'
    }
});

const router = new VueRouter({
    mode: 'hash',
    // mode: 'history',
    routes: routes
});

export const eventBus = new Vue();

new Vue({
  el: '#app',
  router: router,
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js